import { Modal } from "react-bootstrap";
import { SIMULTANEOUS_ACCESS_CONTENT } from "../../../../consts/_simultaneosAccess";
import Logo from "../_logo";
import "./index.scss";

const DEFAULT_CONTENT = {
  title: "Limite de acessos atingido",
  description:
    "No momento, não foi possível liberar o acesso. Aguarde alguns minutos e tente novamente.",
};

interface SimultaneousAccessModalProps {
  show: boolean;
  onHide: () => void;
  code: keyof typeof SIMULTANEOUS_ACCESS_CONTENT;
}

const SimultaneousAccessModal = ({
  show,
  onHide,
  code,
}: SimultaneousAccessModalProps) => {
  const { title, description } =
    SIMULTANEOUS_ACCESS_CONTENT[code] || DEFAULT_CONTENT;

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      className="simultaneous-access-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <p className="simultaneous-access-modal__description">{description}</p>
        <Modal.Footer>
          <Logo variant="lex" />
        </Modal.Footer>
      </Modal.Body>
    </Modal>
  );
};

export default SimultaneousAccessModal;
